module.exports = __webpack_public_path__ + "static/media/canvas_visibility.bb74df42.mp4";